module.exports = __webpack_public_path__ + "img/lock_video.47eaa2c2.svg";